"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPricingAndPurchasingFailedSelector = exports.hasPricingAndPurchasingSucceededSelector = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var numContactsSucceededCheck = function numContactsSucceededCheck(state) {
  var numContactsInCrm = state.numContactsInCrm;
  return numContactsInCrm !== null && numContactsInCrm !== _RequestStatusTypes.default.FAILED;
};

var marketingContactsOnRenewalSucceededCheck = function marketingContactsOnRenewalSucceededCheck(state) {
  var isInApp = (0, _ConfigSelectors.isAppAuthSelector)(state);
  var isInMcBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);

  if (!isInApp || !isInMcBeta) {
    return true;
  }

  var marketingContactsOnRenewal = (0, _MarketingContactsSelectors.marketingContactsOnRenewalSelector)(state);
  return marketingContactsOnRenewal !== null && marketingContactsOnRenewal !== undefined && marketingContactsOnRenewal !== _RequestStatusTypes.default.FAILED;
}; // current required endpoint successes for page load success:
// merchandise, purchase motions, promotions, required onboarding
// & numContactsInCrm, but only if on Marketing Hub Page


var hasPricingAndPurchasingSucceededSelector = function hasPricingAndPurchasingSucceededSelector(state) {
  var merchandise = state.merchandise,
      purchaseMotionRequestStatus = state.purchaseMotionRequestStatus,
      promotions = state.promotions,
      requiredOnboarding = state.requiredOnboarding;
  return !!merchandise && merchandise !== _RequestStatusTypes.default.FAILED && purchaseMotionRequestStatus === _RequestStatusTypes.default.SUCCEEDED && !!promotions.merchEligibleForDirectPromotions && numContactsSucceededCheck(state) && marketingContactsOnRenewalSucceededCheck(state) && requiredOnboarding !== _RequestStatusTypes.default.FAILED && !!Object.keys(requiredOnboarding).length;
};

exports.hasPricingAndPurchasingSucceededSelector = hasPricingAndPurchasingSucceededSelector;

var hasPricingAndPurchasingFailedSelector = function hasPricingAndPurchasingFailedSelector(state) {
  var merchandise = state.merchandise,
      purchaseMotionRequestStatus = state.purchaseMotionRequestStatus,
      promotions = state.promotions,
      numContactsInCrm = state.numContactsInCrm,
      requiredOnboarding = state.requiredOnboarding;
  var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
  var marketingContactsOnRenewal = (0, _MarketingContactsSelectors.marketingContactsOnRenewalSelector)(state);
  return merchandise === _RequestStatusTypes.default.FAILED || purchaseMotionRequestStatus === _RequestStatusTypes.default.FAILED || promotions === _RequestStatusTypes.default.FAILED || numContactsInCrm === _RequestStatusTypes.default.FAILED && !numContactsSucceededCheck(state) || isInMCBeta && marketingContactsOnRenewal === _RequestStatusTypes.default.FAILED || requiredOnboarding === _RequestStatusTypes.default.FAILED;
};

exports.hasPricingAndPurchasingFailedSelector = hasPricingAndPurchasingFailedSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/LoadingStateSelectors.js
// module id = 54
// module chunks = 5 6